import { VariantOption } from '../VariantOption';

export const overwritePaperSelectionIfIncompatible = (
    oldPaperId: string | undefined,
    newSizeId: string,
    paperOptions: VariantOption[]
) => {

    let newPaperId: string | undefined = undefined;

    if (oldPaperId) {

        newPaperId = oldPaperId;

        const paper = paperOptions.find(p => p.value === oldPaperId);
        if (!isCompatible(paper, newSizeId)) {

            const defaultPaperForSize = paperOptions.find(p => isCompatible(p, newSizeId));

            if (defaultPaperForSize) {
                newPaperId = defaultPaperForSize.value;
            }
        }
    }

    return newPaperId;
};

const isCompatible = (paper: VariantOption | undefined, sizeId: string) => {
    return paper && paper.compatibleWith.find(item => item.sizeId === sizeId);
};